/**
 * Which backend the app talks to. Supabase is the default and stays so until the owner approves the switch (docs/RELEASE_LIFECYCLE.md).
 * The Neon backend is selected only by VITE_BACKEND=neon plus two addresses; anything missing or malformed leaves the app unconfigured,
 * exactly as a missing Supabase address does today.
 */
export type BackendKind = 'supabase' | 'neon'

export function resolveBackend(value: unknown): BackendKind {
  return value === 'neon' ? 'neon' : 'supabase'
}

export interface NeonUrls {
  /** The auth Worker (apps/auth), e.g. https://auth.minimany.app. Also the issuer and audience of the database tokens. */
  authUrl: string
  /** The Neon Data API for this environment, e.g. https://ep-….apirest.c-8.eu-central-1.aws.neon.tech/neondb/rest/v1. Identifies the "project" of the local workspace. */
  dataApiUrl: string
}

function cleanUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null
  let url: URL
  try { url = new URL(value.trim()) } catch { return null }
  const local = url.hostname === 'localhost' || url.hostname === '127.0.0.1'
  if (url.protocol !== 'https:' && !(local && url.protocol === 'http:')) return null
  if (url.search || url.hash || url.username || url.password) return null
  return `${url.origin}${url.pathname}`.replace(/\/+$/, '')
}

export function readNeonUrls(env: { VITE_AUTH_URL?: unknown; VITE_DATA_API_URL?: unknown }): NeonUrls | null {
  const authUrl = cleanUrl(env.VITE_AUTH_URL)
  const dataApiUrl = cleanUrl(env.VITE_DATA_API_URL)
  return authUrl && dataApiUrl ? { authUrl, dataApiUrl } : null
}
